const BaseModule = require('../../../../90_utils/base/BaseModule');

class SplitTextStatImage extends BaseModule {

	constructor(el, params) {

		super(el);

		this.$expandedContent;
		this.$window = $(window);
		this.$readMore = this.$el.find('.read-more');
		this.$mobilePhoto = this.$el.find('.mobile-photo');

		this.expandedContentId = 'expanded-content' + (++window.SETTINGS.vars.svgIndex);
		this.transitionDelay;
		this.isIn = false;
	}

	// basemodule methods

	_domReady(){

		let $template = this.$el.find('.expanded-content-template');
		if($template.length){

			this.$expandedContent = $($template.html());
			$template.remove();

			let templateObj = _.findWhere(window.SETTINGS.templates.modals, {id: 'empty'});

			if(templateObj){

				let modalTemplate = _.template(templateObj.template);
				let title = this.$el.find('.title').html();
				let description = this.$expandedContent.html();
				let readMoreURL = this.$expandedContent.attr('data-modal-read-more-url');
				let $modal = $(modalTemplate({
					id: this.expandedContentId,
					title: title,
					description: description,
					viewMoreLinkURL: readMoreURL
				}));

				$('#modal-templates').append($modal);
				$modal.attr('id', 'modal--' + this.expandedContentId);

				this.$el.attr('data-modaal-href', '#modal--' + this.expandedContentId);
				this.$readMore.attr('data-modaal-href', '#modal--' + this.expandedContentId);
				this.$readMore.modaal();
			}
		}
	}

	_addListeners(){
		this.$window.on('scroll', $.proxy(this._onScroll, this));
	}

	_removeListeners(){
		this.$window.off('scroll', $.proxy(this._onScroll, this));
	}

	_onScroll(){

		if(window.SETTINGS.breakpoint.maxWidth('screen-medium')){

			let scrollTop = this.$window.scrollTop();
			let bounds = window.utils.PositioningUtils.getScrollOffset(this.$mobilePhoto);
			let winHeight = window.SETTINGS.coords.winHeight;

			if((bounds.top < winHeight/2) || (bounds.height < winHeight && bounds.bottom < winHeight)){
				if((bounds.top < winHeight/3) || (bounds.height < winHeight && bounds.bottom <= winHeight)){
					if(!this.$el.hasClass('is-in')){
						this.$el.removeClass('is-in-slow');
						this.$el.addClass('is-in');
						this.isIn = true;

						if(this.transitionDelay){
							window.clearTimeout(this.transitionDelay);
						}
						this.transitionDelay = window.setTimeout(() => {
							this.$el.addClass('is-in-showing');
							this.transitionDelay = null;
						}, 50);
					}
				}
				else {
					if(!this.$el.hasClass('is-in-slow')){
						this.$el.removeClass('is-in');
						this.$el.addClass('is-in-slow');
						this.isIn = true;

						if(this.transitionDelay){
							window.clearTimeout(this.transitionDelay);
						}
						this.transitionDelay = window.setTimeout(() => {
							this.$el.addClass('is-in-showing');
							this.transitionDelay = null;
						}, 400);
					}
				}
			}
			else if(bounds.bottom < winHeight/4
				|| bounds.top > winHeight/4*3){

				if(this.isIn){
					this.$el.removeClass('is-in is-in-slow is-in-showing');
					this.isIn = false;

					if(this.transitionDelay){
						window.clearTimeout(this.transitionDelay);
						this.transitionDelay = null;
					}
				}
			}
		}
	}

	//

	_show(){ }
	_hide(){ }

	_enable(){ }
	_disable(){ }

	_domUpdate(){ }
	_resize(){ }
}

module.exports = SplitTextStatImage;
